// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"7677f8c7","529":"220619ad"}[chunkId] + ".chunk.css";
};